module.exports = __webpack_public_path__ + "pdk32-63.jpg?d315bb1f436dc3085a399b34c9bdc073";


//////////////////
// WEBPACK FOOTER
// ./src/assets/materialy/pdk32-63.jpg
// module id = 79
// module chunks = 0